

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";

const subListAtom = atom({key:'subListAtom', default:{item_info:[], production_type:[], 
    subscription_info:[], coupon_info:[], officer:[], payment_term:[],tax:[], subscription_filter:[]}});
const subscriptionEditAtom = atom({key:'subscriptionEditAtom', default:{}});

export  const SetSubMData = () => useSetRecoilState(subListAtom);
export  const GetSubMData = () => useRecoilValue(subListAtom);

export  const SetSubScriptionEdit = () => useSetRecoilState(subscriptionEditAtom);
export  const GetSubscriptionEdit = () => useRecoilValue(subscriptionEditAtom);
export const ResetSubscriptionEdit = ()=> useResetRecoilState(subscriptionEditAtom);


